import templateUrl from './inquiry-analytics-dashboard.component.html';

export const InquiryAnalyticsDashboardComponent = {
    templateUrl
};
